import axios from 'axios';
import apiConfig from '../api.config';

export default function pmsGetUdfConfigRequest({ hotelId }) {
  const {
    host,
    URIs: { pmsConfigHotel },
  } = apiConfig;
  const uri = `${host}${pmsConfigHotel}/${hotelId}/udf`;

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
